import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Login',
			component: () => import('@/components/Login'),
			meta: { title: '登录' }
		}, {
			path: '/login',
			name: 'Login2',
			component: () => import('@/components/Login'),
			meta: { title: '登录' }
		}, {
			path: '/home',
			name: 'Home',
			component: () => import('@/components/Home'),
			meta: { title: '首页' }
		}, {
			path: '/registered',
			name: 'Registered',
			component: () => import('@/components/Registered'),
			meta: { title: '商户注册' }
		}, {
			path: '/forgotPassword',
			name: 'ForgotPassword',
			component: () => import('@/components/ForgotPassword'),
			meta: { title: '找回密码' }
		}, {
			path: '/download',
			name: 'Download',
	        component: () => import('@/components/Download'),
			meta: { title: '下载中心' }
		}, {
			path: '/sales',
			name: 'Sales',
	        component: () => import('@/components/Sales'),
			meta: { title: '零售开单' }
		}, {
			path: '*',
			name: 'NotFound',
	        component: () => import('@/components/NotFound'),
			meta: { title: '页面丢失404' }
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js